import React from 'react';
import { IconType } from 'react-icons';
import { SiMicrosoftonedrive, SiMicrosoftsharepoint } from 'react-icons/si';
import { Connector } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';

interface ConnectorsCardProps {
    connectors: Connector[];
}

interface ConnectorBrand {
    Icon: IconType;
    color: string;
}

/* Simple Icons glyphs are monochrome, so each one carries its official brand colour. */
const CONNECTOR_BRANDS: Record<string, ConnectorBrand> = {
    sharepoint: { Icon: SiMicrosoftsharepoint, color: '#036C70' },
    onedrive: { Icon: SiMicrosoftonedrive, color: '#0078D4' },
};

const ConnectorsCard: React.FC<ConnectorsCardProps> = ({ connectors }) => (
    <DashboardCard title="Enabled Connectors" className="ad-col-connectors">
        <div className="ad-connectors">
            {connectors.map((connector) => {
                const brand = CONNECTOR_BRANDS[connector.id];

                return (
                    <div key={connector.id} className="ad-connector">
                        <div className="ad-connector-icon">
                            {brand ? <brand.Icon size={30} color={brand.color} /> : null}
                        </div>
                        <span className="ad-connector-name">{connector.name}</span>
                        <span className="ad-connector-count">{connector.sites}</span>
                        <span className="ad-connector-unit">sites</span>
                    </div>
                );
            })}
        </div>
    </DashboardCard>
);

export default ConnectorsCard;
